import { connect } from 'react-redux';

import { RootState } from '../../../../reducers';
import FileInput from '../../FileInput/FileInput';
import UploadedFilesStatus from '../../FileUpload/UploadedFilesStatus';
import MissingRequiredDocWarning from '../../MissingRequiredDocWarning/MissingRequiredDocWarning';
import { useDocPresentStatus } from '../../MissingRequiredDocWarning/MissingRequiredDocWarning.hook';
import { documentTypes } from '../../TradingHistory.helpers';
import thstyles from '../../TradingHistory.module.css';
import styles from '../OptionalStatement.module.css';

const mapStateToProps = (state: RootState) => {
    return {
        missingDocs: state?.tradingHistory?.missing
    };
};

const ArticlesOfAssociation = ({
    isOptional,
    missingDocs
}: {
    isOptional: boolean;
    missingDocs: [];
}) => {
    const isDocMissing = useDocPresentStatus(
        missingDocs,
        'gesellschaftsvertrag_hochladen'
    );

    return (
        <>
            <div className={thstyles.headerSection}>
                <h3 className={thstyles.title}>Gesellschaftsvertrag</h3>
                {isDocMissing && (
                    <MissingRequiredDocWarning dataTestId="gesellschaftsvertrag-warning-required" />
                )}
            </div>
            <div
                className={styles.CurrentManagementSection}
                data-testid="aoa-uploads">
                <div className={styles.descriptionContainer}>
                    <p>Bitte laden Sie Ihren Gesellschaftsvertrag hoch.</p>
                </div>
                <FileInput
                    documentType={documentTypes.gesellschaftsvertrag_hochladen}
                    buttonText="Gesellschaftsvertrag hochladen"
                    isOptional={isOptional}
                />
            </div>
            <UploadedFilesStatus
                documentType={documentTypes.gesellschaftsvertrag_hochladen}
            />
        </>
    );
};

export default connect(mapStateToProps)(ArticlesOfAssociation);
